import React from 'react';
import { Head, Link } from '@inertiajs/inertia-react';
import Authenticated from '@/Layouts/Authenticated';

import CouponCard from '@/Components/Coupons/CouponCard';
import Button from '@/Components/Button';

const Index = ({ coupons, office, ...props }) => {
    return (
        <Authenticated
            store={props.store}
            branchOffice={office}
            auth={props.auth}
            errors={props.errors}
            header={<h2 className="font-semibold text-xl text-gray-800 leading-tight">Cupones de descuento</h2>}
        >
            <Head title="Lista de cupones - Cerogrado" />
            <div className="w-full flex justify-center px-4 pt-4 mb-4">
                <Link href={route('coupons.create', {office: office.slug})}>
                    <Button type="button">Crear un cupon de descuento</Button>
                </Link>
            </div>
            <div className="max-w-7xl w-full px-4 mx-auto">
                {Boolean(coupons?.length) && coupons.map(coupon => (
                    <CouponCard office={office} {...coupon} key={`coupon-item-${coupon.id}`} />
                ))}
            </div>
        </Authenticated>
    )
}

export default Index;
